"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  JOB: 'job',
  INTERNSHIPS: 'internships',
  EVENT: 'event'
};
exports.default = _default;